import { send } from 'server';

export const changePassword = ({ newPassword, oldPassword }) => send({
    ID: 31028,
    responses: [31029, 31030],
    description: 'Change password',
    newPassword,
    oldPassword
});
